import {t} from '@lingui/core/macro';

import {OptionType} from '../model/types';

export function getYesNoOptions(): OptionType[] {
    return [
        {label: t`Да`, value: 'true'},
        {label: t`Нет`, value: 'false'},
    ];
}

export function getActiveOptions(): OptionType[] {
    return [
        {label: t`Активные`, value: 'true'},
        {label: t`Неактивные`, value: 'false'},
    ];
}
